import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "@phosphor-icons/react";

const STORAGE_KEY = "invisique_cookie_consent_v1";

export default function CookieBanner() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const existing = localStorage.getItem(STORAGE_KEY);
        if (!existing) {
            const t = setTimeout(() => setShow(true), 1500);
            return () => clearTimeout(t);
        }
    }, []);

    const handleChoice = (choice) => {
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ choice, ts: new Date().toISOString() })
        );
        setShow(false);
    };

    if (!show) return null;

    return (
        <div
            className="fixed bottom-5 left-5 right-5 sm:left-auto sm:right-5 sm:max-w-md z-40 rounded-2xl bg-white border border-border shadow-2xl p-5 animate-in slide-in-from-bottom-4 fade-in duration-300"
            data-testid="cookie-banner"
        >
            <button
                onClick={() => handleChoice("dismissed")}
                className="absolute top-3 right-3 p-1 rounded hover:bg-muted transition-colors"
                aria-label="Close"
            >
                <X size={14} weight="bold" />
            </button>
            <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                    <Cookie size={18} weight="duotone" color="hsl(192 100% 31%)" />
                </div>
                <div className="flex-1">
                    <div className="font-display font-semibold text-sm mb-1">We use cookies</div>
                    <p className="text-xs text-muted-foreground leading-relaxed mb-4">
                        Essential cookies keep you logged in. Optional analytics cookies help us improve Invisique™. Read
                        our{" "}
                        <Link to="/privacy" className="text-primary underline">
                            Privacy Policy
                        </Link>
                        .
                    </p>
                    <div className="flex gap-2">
                        <Button
                            size="sm"
                            variant="outline"
                            className="h-8 text-xs rounded-full"
                            onClick={() => handleChoice("essential")}
                            data-testid="cookie-essential-btn"
                        >
                            Essential only
                        </Button>
                        <Button
                            size="sm"
                            className="h-8 text-xs rounded-full"
                            onClick={() => handleChoice("all")}
                            data-testid="cookie-accept-btn"
                        >
                            Accept all
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
